import { CaseStatus } from 'share/domain/caseStatus'
import {
  ActiveCase,
  getEmptyActiveCase
} from 'reducers/activecase/activecaseSlice'

function saveActiveCaseStatusListToSessionStorage(
  payload: CaseStatus[] | null | undefined
): void {
  const sessionStor = window.sessionStorage
  if (payload && payload.length > 0) {
    payload.forEach((caseStatus, index) => {
      const key = 'acase-matter-statusItem' + index.toString()
      sessionStor.setItem(key + '-name', caseStatus.name)
      sessionStor.setItem(key + '-descr', caseStatus.description)
      sessionStor.setItem(key + '-curr', caseStatus.current.toString())
    })
  }
}

function removeActiveCaseStatusListFromSessionStorage(): void {
  const sessionStor = window.sessionStorage
  for (let index = 0; index < 10; index++) {
    const keyName = 'acase-matter-statusItem' + index.toString() + '-name'
    const keyDescr = 'acase-matter-statusItem' + index.toString() + '-descr'
    const keyCurr = 'acase-matter-statusItem' + index.toString() + '-curr'

    sessionStor.removeItem(keyName)
    sessionStor.removeItem(keyDescr)
    sessionStor.removeItem(keyCurr)
  }
}

function getActiveCaseStatusListFromSessionStorage(
  index: number
): CaseStatus | null {
  const sessionStor = window.sessionStorage
  const keyName = 'acase-matter-statusItem' + index.toString() + '-name'
  const keyDescr = 'acase-matter-statusItem' + index.toString() + '-descr'
  const keyCurr = 'acase-matter-statusItem' + index.toString() + '-curr'

  const name = sessionStor.getItem(keyName)
  const descr = sessionStor.getItem(keyDescr)
  const curr = sessionStor.getItem(keyCurr)

  if (name && descr && curr) {
    const current = curr === 'true'
    return { name: name, description: descr, current: current }
  } else {
    return null
  }
}

export function saveActiveCaseToSessionStorage(payload: ActiveCase): void {
  const sessionStor = window.sessionStorage
  sessionStor.setItem('acase-isActiveCase', payload.isActiveCase.toString())
  if (payload.matter && payload.matter.id) {
    sessionStor.setItem('acase-matter-id', payload.matter.id.toString())
    sessionStor.setItem(
      'acase-matter-bccreference',
      payload.matter.bccReference.toString()
    )
    if (payload.matter.caseNumber) {
      sessionStor.setItem('acase-matter-caseNum', payload.matter.caseNumber)
    } else {
      sessionStor.removeItem('acase-matter-caseNum')
    }
    if (payload.matter.active) {
      sessionStor.setItem(
        'acase-matter-active',
        payload.matter.active.toString()
      )
    } else {
      sessionStor.removeItem('acase-matter-active')
    }

    sessionStor.setItem(
      'acase-matter-attorneyid',
      payload.matter.attorneyId.toString()
    )
    if (payload.matter.attorneyName) {
      sessionStor.setItem(
        'acase-matter-attorneyName',
        payload.matter.attorneyName
      )
    } else {
      sessionStor.removeItem('acase-matter-attorneyName')
    }

    if (payload.matter.attorneyAvatarUrl) {
      sessionStor.setItem(
        'acase-matter-attorneyavatar',
        payload.matter.attorneyAvatarUrl
      )
    } else {
      sessionStor.removeItem('acase-matter-attorneyavatar')
    }

    sessionStor.setItem('acase-matter-caseType', payload.matter.caseType)
    if (payload.matter.lastVisitedDate) {
      sessionStor.setItem('acase-matter-lvdate', payload.matter.lastVisitedDate)
    } else {
      sessionStor.removeItem('acase-matter-lvdate')
    }
    sessionStor.setItem('acase-matter-status', payload.matter.status)
    if (payload.matter.openDate) {
      sessionStor.setItem('acase-matter-odate', payload.matter.openDate)
    } else {
      sessionStor.removeItem('acase-matter-odate')
    }

    if (payload.matter.isJoint) {
      sessionStor.setItem(
        'acase-matter-isjoint',
        payload.matter.isJoint.toString()
      )
    } else {
      sessionStor.removeItem('acase-matter-isjoint')
    }

    if (payload.matter.debtor1FirstCourseForJointCaseOrders) {
      sessionStor.setItem(
        'acase-matter-debtor1firstcourseforjointcaseorders',
        payload.matter.debtor1FirstCourseForJointCaseOrders.toString()
      )
    } else {
      sessionStor.removeItem(
        'acase-matter-debtor1firstcourseforjointcaseorders'
      )
    }

    if (payload.matter.debtor1SecondCourseForJointCaseOrders) {
      sessionStor.setItem(
        'acase-matter-debtor1secondcourseforjointcaseorders',
        payload.matter.debtor1SecondCourseForJointCaseOrders.toString()
      )
    } else {
      sessionStor.removeItem(
        'acase-matter-debtor1secondcourseforjointcaseorders'
      )
    }

    if (payload.matter.debtor1EmailAddress) {
      sessionStor.setItem(
        'acase-matter-debtor1emailaddr',
        payload.matter.debtor1EmailAddress
      )
    } else {
      sessionStor.removeItem('acase-matter-debtor1emailaddr')
    }

    if (payload.matter.debtor1FirstName) {
      sessionStor.setItem(
        'acase-matter-debtor1firstname',
        payload.matter.debtor1FirstName
      )
    } else {
      sessionStor.removeItem('acase-matter-debtor1firstname')
    }

    if (payload.matter.debtor1LastName) {
      sessionStor.setItem(
        'acase-matter-debtor1lastname',
        payload.matter.debtor1LastName
      )
    } else {
      sessionStor.removeItem('acase-matter-debtor1lastname')
    }

    if (payload.matter.debtor2EmailAddress) {
      sessionStor.setItem(
        'acase-matter-debtor2emailaddr',
        payload.matter.debtor2EmailAddress
      )
    } else {
      sessionStor.removeItem('acase-matter-debtor2emailaddr')
    }

    if (payload.matter.debtor2FirstName) {
      sessionStor.setItem(
        'acase-matter-debtor2firstname',
        payload.matter.debtor2FirstName
      )
    } else {
      sessionStor.removeItem('acase-matter-debtor2firstname')
    }

    if (payload.matter.debtor2LastName) {
      sessionStor.setItem(
        'acase-matter-debtor2lastname',
        payload.matter.debtor2LastName
      )
    } else {
      sessionStor.removeItem('acase-matter-debtor2lastname')
    }

    sessionStor.setItem(
      'acase-matter-isaienabled',
      payload.matter.isAiEnabled.toString()
    )

    sessionStor.setItem(
      'acase-matter-ischatbotenabled',
      payload.matter.isChatBotEnabled.toString()
    )

    sessionStor.setItem(
      'acase-matter-ischecklistcomplete',
      payload.matter.isCompleteAllChecklistUploadedDocuments.toString()
    )

    sessionStor.setItem(
      'acase-matter-hasLegacyOrder',
      payload.matter.hasLegacyOrder.toString()
    )

    if (payload.matter.clientCode) {
      sessionStor.setItem('acase-matter-clientcode', payload.matter.clientCode)
    } else {
      sessionStor.removeItem('acase-matter-clientcode')
    }

    if (payload.matter.organizationalUnitIdKey) {
      sessionStor.setItem(
        'acase-matter-organizationalunitidkey',
        payload.matter.organizationalUnitIdKey.toString()
      )
    } else {
      sessionStor.removeItem('acase-matter-organizationalunitidkey')
    }

    sessionStor.setItem(
      'acase-matter-debtor1hasplacedfirstcourseorder',
      payload.matter.debtor1HasPlacedFirstCourseOrder.toString()
    )

    sessionStor.setItem(
      'acase-matter-debtor1hasplacedsecondcourseorder',
      payload.matter.debtor1HasPlacedSecondCourseOrder.toString()
    )

    if (payload.matter.debtor1HasPlacedFirstCourseOrderStatus) {
      sessionStor.setItem(
        'acase-matter-debtor1hasplacedfirstcourseorderstatus',
        payload.matter.debtor1HasPlacedFirstCourseOrderStatus.toString()
      )
    } else {
      sessionStor.removeItem(
        'acase-matter-debtor1hasplacedfirstcourseorderstatus'
      )
    }

    if (payload.matter.debtor1HasPlacedSecondCourseOrderStatus) {
      sessionStor.setItem(
        'acase-matter-debtor1hasplacedsecondcourseorderstatus',
        payload.matter.debtor1HasPlacedSecondCourseOrderStatus.toString()
      )
    } else {
      sessionStor.removeItem(
        'acase-matter-debtor1hasplacedsecondcourseorderstatus'
      )
    }

    if (payload.matter.debtor1HasPlacedFirstCourseOrderStatusMessage) {
      sessionStor.setItem(
        'acase-matter-debtor1hasplacedfirstcourseorderstatusmessage',
        payload.matter.debtor1HasPlacedFirstCourseOrderStatusMessage
      )
    } else {
      sessionStor.removeItem(
        'acase-matter-debtor1hasplacedfirstcourseorderstatusmessage'
      )
    }

    if (payload.matter.debtor1HasPlacedSecondCourseOrderStatusMessage) {
      sessionStor.setItem(
        'acase-matter-debtor1hasplacedsecondcourseorderstatusmessage',
        payload.matter.debtor1HasPlacedSecondCourseOrderStatusMessage
      )
    } else {
      sessionStor.removeItem(
        'acase-matter-debtor1hasplacedsecondcourseorderstatusmessage'
      )
    }

    if (payload.matter.debtor1FirstCourseOrderStep) {
      sessionStor.setItem(
        'acase-matter-debtor1firstcourseorderstep',
        payload.matter.debtor1FirstCourseOrderStep.toString()
      )
    } else {
      sessionStor.removeItem('acase-matter-debtor1firstcourseorderstep')
    }

    if (payload.matter.debtor1SecondCourseOrderStep) {
      sessionStor.setItem(
        'acase-matter-debtor1secondcourseorderstep',
        payload.matter.debtor1SecondCourseOrderStep.toString()
      )
    } else {
      sessionStor.removeItem('acase-matter-debtor1secondcourseorderstep')
    }

    if (payload.matter.debtor2FirstCourseForJointCaseOrders) {
      sessionStor.setItem(
        'acase-matter-debtor2firstcourseforjointcaseorders',
        payload.matter.debtor2FirstCourseForJointCaseOrders.toString()
      )
    } else {
      sessionStor.removeItem(
        'acase-matter-debtor2firstcourseforjointcaseorders'
      )
    }

    if (payload.matter.debtor2SecondCourseForJointCaseOrders) {
      sessionStor.setItem(
        'acase-matter-debtor2secondcourseforjointcaseorders',
        payload.matter.debtor2SecondCourseForJointCaseOrders.toString()
      )
    } else {
      sessionStor.removeItem(
        'acase-matter-debtor2secondcourseforjointcaseorders'
      )
    }

    sessionStor.setItem(
      'acase-matter-debtor2hasplacedfirstcourseorder',
      payload.matter.debtor2HasPlacedFirstCourseOrder.toString()
    )

    sessionStor.setItem(
      'acase-matter-debtor2hasplacedsecondcourseorder',
      payload.matter.debtor2HasPlacedSecondCourseOrder.toString()
    )

    if (payload.matter.debtor2HasPlacedFirstCourseOrderStatus) {
      sessionStor.setItem(
        'acase-matter-debtor2hasplacedfirstcourseorderstatus',
        payload.matter.debtor2HasPlacedFirstCourseOrderStatus.toString()
      )
    } else {
      sessionStor.removeItem(
        'acase-matter-debtor2hasplacedfirstcourseorderstatus'
      )
    }

    if (payload.matter.debtor2HasPlacedSecondCourseOrderStatus) {
      sessionStor.setItem(
        'acase-matter-debtor2hasplacedsecondcourseorderstatus',
        payload.matter.debtor2HasPlacedSecondCourseOrderStatus.toString()
      )
    } else {
      sessionStor.removeItem(
        'acase-matter-debtor2hasplacedsecondcourseorderstatus'
      )
    }

    if (payload.matter.debtor2HasPlacedFirstCourseOrderStatusMessage) {
      sessionStor.setItem(
        'acase-matter-debtor2hasplacedfirstcourseorderstatusmessage',
        payload.matter.debtor2HasPlacedFirstCourseOrderStatusMessage
      )
    } else {
      sessionStor.removeItem(
        'acase-matter-debtor2hasplacedfirstcourseorderstatusmessage'
      )
    }

    if (payload.matter.debtor2HasPlacedSecondCourseOrderStatusMessage) {
      sessionStor.setItem(
        'acase-matter-debtor2hasplacedsecondcourseorderstatusmessage',
        payload.matter.debtor2HasPlacedSecondCourseOrderStatusMessage
      )
    } else {
      sessionStor.removeItem(
        'acase-matter-debtor2hasplacedsecondcourseorderstatusmessage'
      )
    }

    if (payload.matter.debtor2FirstCourseOrderStep) {
      sessionStor.setItem(
        'acase-matter-debtor2firstcourseorderstep',
        payload.matter.debtor2FirstCourseOrderStep.toString()
      )
    } else {
      sessionStor.removeItem('acase-matter-debtor2firstcourseorderstep')
    }

    if (payload.matter.debtor2SecondCourseOrderStep) {
      sessionStor.setItem(
        'acase-matter-debtor2secondcourseorderstep',
        payload.matter.debtor2SecondCourseOrderStep.toString()
      )
    } else {
      sessionStor.removeItem('acase-matter-debtor2secondcourseorderstep')
    }

    sessionStor.setItem(
      'acase-matter-show-questionnaire',
      payload.matter.questionnaireDisplayInClientPortalFlag.toString()
    )

    if (payload.matter.questionnaireExpectedCompletionDate) {
      sessionStor.setItem(
        'acase-matter-qexpectedcomplete',
        payload.matter.questionnaireExpectedCompletionDate
      )
    } else {
      sessionStor.removeItem('acase-matter-qexpectedcomplete')
    }

    if (payload.matter.questionnaireExpectedCompletionMonth) {
      sessionStor.setItem(
        'acase-matter-qexpectedmonth',
        payload.matter.questionnaireExpectedCompletionMonth
      )
    } else {
      sessionStor.removeItem('acase-matter-qexpectedmonth')
    }

    if (payload.matter.questionnaireExpectedCompletionDay) {
      sessionStor.setItem(
        'acase-matter-qexpectedday',
        payload.matter.questionnaireExpectedCompletionDay
      )
    } else {
      sessionStor.removeItem('acase-matter-qexpectedday')
    }

    if (payload.matter.questionnaireExpectedCompletionYear) {
      sessionStor.setItem(
        'acase-matter-qexpectedyear',
        payload.matter.questionnaireExpectedCompletionYear
      )
    } else {
      sessionStor.removeItem('acase-matter-qexpectedyear')
    }

    if (payload.matter.questionnaireExpectedCompletionFormatted) {
      sessionStor.setItem(
        'acase-matter-qexpectedformatted',
        payload.matter.questionnaireExpectedCompletionFormatted
      )
    } else {
      sessionStor.removeItem('acase-matter-qexpectedformatted')
    }

    if (payload.matter.questionnaireInstructions) {
      sessionStor.setItem(
        'acase-matter-qinstr',
        payload.matter.questionnaireInstructions
      )
    } else {
      sessionStor.removeItem('acase-matter-qinstr')
    }

    sessionStor.setItem(
      'acase-matter-qshow-instr',
      payload.matter.questionnaireShownInstructionsFlag.toString()
    )

    sessionStor.setItem(
      'acase-matter-qshow-terms',
      payload.matter.questionnaireShownTermsAndConditionsFlag.toString()
    )

    if (payload.matter.dashBoardTitle) {
      sessionStor.setItem('acase-matter-dbtitle', payload.matter.dashBoardTitle)
    } else {
      sessionStor.removeItem('acase-matter-dbtitle')
    }

    if (payload.matter.dashBoardHeaderDescription) {
      sessionStor.setItem(
        'acase-matter-dbheaderdescr',
        payload.matter.dashBoardHeaderDescription
      )
    } else {
      sessionStor.removeItem('acase-matter-dbheaderdescr')
    }

    if (payload.matter.dashBoardCurrentStatusDescription) {
      sessionStor.setItem(
        'acase-matter-dbcurrstatusdescr',
        payload.matter.dashBoardCurrentStatusDescription
      )
    } else {
      sessionStor.removeItem('acase-matter-dbcurrstatusdescr')
    }

    if (payload.matter.dashBoardShowSubmitDocumentsFlag) {
      sessionStor.setItem(
        'acase-matter-dbshowsubmit',
        payload.matter.dashBoardShowSubmitDocumentsFlag.toString()
      )
    } else {
      sessionStor.removeItem('acase-matter-dbshowsubmit')
    }

    if (payload.matter.dashBoardCourseNumber) {
      sessionStor.setItem(
        'acase-matter-dbcoursenum',
        payload.matter.dashBoardCourseNumber
      )
    } else {
      sessionStor.removeItem('acase-matter-dbcoursenum')
    }

    if (payload.matter.statuses && payload.matter.statuses.length > 0) {
      saveActiveCaseStatusListToSessionStorage(payload.matter.statuses)
    } else {
      removeActiveCaseStatusListFromSessionStorage()
    }

    if (payload.matter.firm) {
      sessionStor.setItem(
        'acase-matter-firm-id',
        payload.matter.firm.id.toString()
      )
      sessionStor.setItem('acase-matter-firm-name', payload.matter.firm.name)
      if (payload.matter.firm.officeId) {
        sessionStor.setItem(
          'acase-matter-firm-offId',
          payload.matter.firm.officeId
        )
      } else {
        sessionStor.removeItem('acase-matter-firm-offId')
      }
      if (payload.matter.firm.emailAddress) {
        sessionStor.setItem(
          'acase-matter-firm-email',
          payload.matter.firm.emailAddress
        )
      } else {
        sessionStor.removeItem('acase-matter-firm-email')
      }
      if (payload.matter.firm.iconUrl) {
        sessionStor.setItem(
          'acase-matter-firm-icon',
          payload.matter.firm.iconUrl
        )
      } else {
        sessionStor.removeItem('acase-matter-firm-icon')
      }

      if (payload.matter.firm.street) {
        sessionStor.setItem(
          'acase-matter-firm-street',
          payload.matter.firm.street
        )
      } else {
        sessionStor.removeItem('acase-matter-firm-street')
      }

      if (payload.matter.firm.city) {
        sessionStor.setItem('acase-matter-firm-city', payload.matter.firm.city)
      } else {
        sessionStor.removeItem('acase-matter-firm-city')
      }

      if (payload.matter.firm.state) {
        sessionStor.setItem(
          'acase-matter-firm-state',
          payload.matter.firm.state
        )
      } else {
        sessionStor.removeItem('acase-matter-firm-state')
      }

      if (payload.matter.firm.zip) {
        sessionStor.setItem('acase-matter-firm-zip', payload.matter.firm.zip)
      } else {
        sessionStor.removeItem('acase-matter-firm-zip')
      }

      if (payload.matter.firm.phone) {
        sessionStor.setItem(
          'acase-matter-firm-phone',
          payload.matter.firm.phone
        )
      } else {
        sessionStor.removeItem('acase-matter-firm-phone')
      }

      if (payload.matter.firm.fax) {
        sessionStor.setItem('acase-matter-firm-fax', payload.matter.firm.fax)
      } else {
        sessionStor.removeItem('acase-matter-firm-fax')
      }

      if (payload.matter.firm.website) {
        sessionStor.setItem(
          'acase-matter-firm-wsite',
          payload.matter.firm.website
        )
      } else {
        sessionStor.removeItem('acase-matter-firm-wsite')
      }
    } else {
      sessionStor.removeItem('acase-matter-firm-id')
      sessionStor.removeItem('acase-matter-firm-name')
      sessionStor.removeItem('acase-matter-firm-offId')
      sessionStor.removeItem('acase-matter-firm-email')
      sessionStor.removeItem('acase-matter-firm-street')
      sessionStor.removeItem('acase-matter-firm-city')
      sessionStor.removeItem('acase-matter-firm-state')
      sessionStor.removeItem('acase-matter-firm-zip')
      sessionStor.removeItem('acase-matter-firm-phone')
      sessionStor.removeItem('acase-matter-firm-fax')
      sessionStor.removeItem('acase-matter-firm-wsite')
    }
  } else {
    sessionStor.removeItem('acase-matter-id')
    sessionStor.removeItem('acase-matter-bccreference')
    sessionStor.removeItem('acase-matter-caseNum')
    sessionStor.removeItem('acase-matter-active')
    sessionStor.removeItem('acase-matter-attorneyid')
    sessionStor.removeItem('acase-matter-attorneyName')
    sessionStor.removeItem('acase-matter-attorneyavatar')
    sessionStor.removeItem('acase-matter-caseType')
    sessionStor.removeItem('acase-matter-lvdate')
    sessionStor.removeItem('acase-matter-status')
    sessionStor.removeItem('acase-matter-odate')
    sessionStor.removeItem('acase-matter-statuses')
    sessionStor.removeItem('acase-matter-isjoint')
    sessionStor.removeItem('acase-matter-debtor1firstcourseforjointcaseorders')
    sessionStor.removeItem('acase-matter-debtor1secondcourseforjointcaseorders')
    sessionStor.removeItem('acase-matter-debtor1emailaddr')
    sessionStor.removeItem('acase-matter-debtor1firstname')
    sessionStor.removeItem('acase-matter-debtor1lastname')
    sessionStor.removeItem('acase-matter-debtor2emailaddr')
    sessionStor.removeItem('acase-matter-debtor2firstname')
    sessionStor.removeItem('acase-matter-debtor2lastname')
    sessionStor.removeItem('acase-matter-isaienabled')
    sessionStor.removeItem('acase-matter-ischatbotenabled')
    sessionStor.removeItem('acase-matter-ischecklistcomplete')
    sessionStor.removeItem('acase-matter-hasLegacyOrder')
    sessionStor.removeItem('acase-matter-clientcode')
    sessionStor.removeItem('acase-matter-organizationalunitidkey')
    sessionStor.removeItem('acase-matter-debtor1hasplacedfirstcourseorder')
    sessionStor.removeItem('acase-matter-debtor1hasplacedsecondcourseorder')
    sessionStor.removeItem(
      'acase-matter-debtor1hasplacedfirstcourseorderstatus'
    )
    sessionStor.removeItem(
      'acase-matter-debtor1hasplacedsecondcourseorderstatus'
    )
    sessionStor.removeItem(
      'acase-matter-debtor1hasplacedfirstcourseorderstatusmessage'
    )
    sessionStor.removeItem(
      'acase-matter-debtor1hasplacedsecondcourseorderstatusmessage'
    )
    sessionStor.removeItem('acase-matter-debtor1firstcourseorderstep')
    sessionStor.removeItem('acase-matter-debtor1secondcourseorderstep')

    sessionStor.removeItem('acase-matter-debtor2firstcourseforjointcaseorders')
    sessionStor.removeItem('acase-matter-debtor2secondcourseforjointcaseorders')
    sessionStor.removeItem('acase-matter-debtor2hasplacedfirstcourseorder')
    sessionStor.removeItem('acase-matter-debtor2hasplacedsecondcourseorder')
    sessionStor.removeItem(
      'acase-matter-debtor2hasplacedfirstcourseorderstatus'
    )
    sessionStor.removeItem(
      'acase-matter-debtor2hasplacedsecondcourseorderstatus'
    )
    sessionStor.removeItem(
      'acase-matter-debtor2hasplacedfirstcourseorderstatusmessage'
    )
    sessionStor.removeItem(
      'acase-matter-debtor2hasplacedsecondcourseorderstatusmessage'
    )
    sessionStor.removeItem('acase-matter-debtor2firstcourseorderstep')
    sessionStor.removeItem('acase-matter-debtor2secondcourseorderstep')

    sessionStor.removeItem('acase-matter-show-questionnaire')
    sessionStor.removeItem('acase-matter-qexpectedcomplete')
    sessionStor.removeItem('acase-matter-qexpectedmonth')
    sessionStor.removeItem('acase-matter-qexpectedday')
    sessionStor.removeItem('acase-matter-qexpectedyear')
    sessionStor.removeItem('acase-matter-qexpectedformatted')
    sessionStor.removeItem('acase-matter-qinstr')
    sessionStor.removeItem('acase-matter-qshow-instr')
    sessionStor.removeItem('acase-matter-qshow-terms')
    sessionStor.removeItem('acase-matter-dbtitle')
    sessionStor.removeItem('acase-matter-dbheaderdescr')
    sessionStor.removeItem('acase-matter-dbcurrstatusdescr')
    sessionStor.removeItem('acase-matter-dbshowsubmit')
    sessionStor.removeItem('acase-matter-dbcoursenum')
    sessionStor.removeItem('acase-matter-firm-id')
    sessionStor.removeItem('acase-matter-firm-name')
    sessionStor.removeItem('acase-matter-firm-offId')
    sessionStor.removeItem('acase-matter-firm-email')
    sessionStor.removeItem('acase-matter-firm-icon')
    sessionStor.removeItem('acase-matter-firm-street')
    sessionStor.removeItem('acase-matter-firm-city')
    sessionStor.removeItem('acase-matter-firm-state')
    sessionStor.removeItem('acase-matter-firm-zip')
    sessionStor.removeItem('acase-matter-firm-phone')
    sessionStor.removeItem('acase-matter-firm-fax')
    sessionStor.removeItem('acase-matter-firm-wsite')
  }
}

export function loadActiveCaseFromSessionStorage(): ActiveCase {
  const sessionStor = window.sessionStorage
  const activeCase = getEmptyActiveCase()
  activeCase.isActiveCase = false
  const isActiveCase = sessionStor.getItem('acase-isActiveCase')
  if (isActiveCase) {
    activeCase.isActiveCase = isActiveCase === 'true'
  }

  if (activeCase.matter) {
    const matterId = sessionStor.getItem('acase-matter-id')
    if (matterId) {
      activeCase.matter.id = parseInt(matterId)
    }
    const bccReference = sessionStor.getItem('acase-matter-bccreference')
    if (bccReference) {
      activeCase.matter.bccReference = parseInt(bccReference)
    }
    const caseNumber = sessionStor.getItem('acase-matter-caseNum')
    if (caseNumber) {
      activeCase.matter.caseNumber = caseNumber
    }
    const caseActive = sessionStor.getItem('acase-matter-caseNum')
    if (caseActive) {
      activeCase.matter.active = caseActive === 'true'
    }

    const attorneyId = sessionStor.getItem('acase-matter-attorneyid')
    if (attorneyId) {
      activeCase.matter.attorneyId = parseInt(attorneyId)
    }

    const attorneyName = sessionStor.getItem('acase-matter-attorneyName')
    if (attorneyName) {
      activeCase.matter.attorneyName = attorneyName
    }

    const attorneyAvatar = sessionStor.getItem('acase-matter-attorneyavatar')
    if (attorneyAvatar) {
      activeCase.matter.attorneyAvatarUrl = attorneyAvatar
    }

    const caseType = sessionStor.getItem('acase-matter-caseType')
    if (caseType) {
      activeCase.matter.caseType = caseType
    }

    const lastVisitedDate = sessionStor.getItem('acase-matter-lvdate')
    if (lastVisitedDate) {
      activeCase.matter.lastVisitedDate = lastVisitedDate
    }

    const status = sessionStor.getItem('acase-matter-status')
    if (status) {
      activeCase.matter.status = status
    }

    const openDate = sessionStor.getItem('acase-matter-odate')
    if (openDate) {
      activeCase.matter.openDate = openDate
    }

    const isJointCase = sessionStor.getItem('acase-matter-isjoint')
    if (isJointCase) {
      activeCase.matter.isJoint = isJointCase === 'true'
    }

    const debtor1FirstCourseForJointCaseOrders = sessionStor.getItem(
      'acase-matter-debtor1firstcourseforjointcaseorders'
    )
    if (debtor1FirstCourseForJointCaseOrders) {
      activeCase.matter.debtor1FirstCourseForJointCaseOrders = parseInt(
        debtor1FirstCourseForJointCaseOrders
      )
    }

    const debtor1SecondCourseForJointCaseOrders = sessionStor.getItem(
      'acase-matter-debtor1secondcourseforjointcaseorders'
    )
    if (debtor1SecondCourseForJointCaseOrders) {
      activeCase.matter.debtor1SecondCourseForJointCaseOrders = parseInt(
        debtor1SecondCourseForJointCaseOrders
      )
    }

    const debtor1EmailAddress = sessionStor.getItem(
      'acase-matter-debtor1emailaddr'
    )
    if (debtor1EmailAddress) {
      activeCase.matter.debtor1EmailAddress = debtor1EmailAddress
    }

    const debtor1FirstName = sessionStor.getItem(
      'acase-matter-debtor1firstname'
    )
    if (debtor1FirstName) {
      activeCase.matter.debtor1FirstName = debtor1FirstName
    }

    const debtor1LastName = sessionStor.getItem('acase-matter-debtor1lastname')
    if (debtor1LastName) {
      activeCase.matter.debtor1LastName = debtor1LastName
    }

    const debtor2EmailAddress = sessionStor.getItem(
      'acase-matter-debtor2emailaddr'
    )
    if (debtor2EmailAddress) {
      activeCase.matter.debtor2EmailAddress = debtor2EmailAddress
    }

    const debtor2FirstName = sessionStor.getItem(
      'acase-matter-debtor2firstname'
    )
    if (debtor2FirstName) {
      activeCase.matter.debtor2FirstName = debtor2FirstName
    }

    const debtor2LastName = sessionStor.getItem('acase-matter-debtor2lastname')
    if (debtor2LastName) {
      activeCase.matter.debtor2LastName = debtor2LastName
    }

    const isAiEnabled = sessionStor.getItem('acase-matter-isaienabled')
    if (isAiEnabled) {
      activeCase.matter.isAiEnabled = isAiEnabled === 'true'
    }

    const isChatBotEnabled = sessionStor.getItem(
      'acase-matter-ischatbotenabled'
    )
    if (isChatBotEnabled) {
      activeCase.matter.isChatBotEnabled = isChatBotEnabled === 'true'
    }

    const isCompleteAllChecklistUploadedDocuments = sessionStor.getItem(
      'acase-matter-ischecklistcomplete'
    )
    if (isCompleteAllChecklistUploadedDocuments) {
      activeCase.matter.isCompleteAllChecklistUploadedDocuments =
        isCompleteAllChecklistUploadedDocuments === 'true'
    }

    const hasLegacyOrder = sessionStor.getItem('acase-matter-hasLegacyOrder')
    if (hasLegacyOrder) {
      activeCase.matter.hasLegacyOrder = hasLegacyOrder === 'true'
    }

    const clientCode = sessionStor.getItem('acase-matter-clientcode')
    if (clientCode) {
      activeCase.matter.clientCode = clientCode
    }

    const organizationalUnitIdKey = sessionStor.getItem(
      'acase-matter-organizationalunitidkey'
    )
    if (organizationalUnitIdKey) {
      activeCase.matter.organizationalUnitIdKey = parseInt(
        organizationalUnitIdKey
      )
    }

    const debtor1HasPlacedFirstCourseOrder = sessionStor.getItem(
      'acase-matter-debtor1hasplacedfirstcourseorder'
    )
    if (debtor1HasPlacedFirstCourseOrder) {
      activeCase.matter.debtor1HasPlacedFirstCourseOrder =
        debtor1HasPlacedFirstCourseOrder === 'true'
    }

    const debtor1HasPlacedSecondCourseOrder = sessionStor.getItem(
      'acase-matter-debtor1hasplacedsecondcourseorder'
    )
    if (debtor1HasPlacedSecondCourseOrder) {
      activeCase.matter.debtor1HasPlacedSecondCourseOrder =
        debtor1HasPlacedSecondCourseOrder === 'true'
    }

    const debtor1HasPlacedFirstCourseOrderStatus = sessionStor.getItem(
      'acase-matter-debtor1hasplacedfirstcourseorderstatus'
    )
    if (debtor1HasPlacedFirstCourseOrderStatus) {
      activeCase.matter.debtor1HasPlacedFirstCourseOrderStatus = parseInt(
        debtor1HasPlacedFirstCourseOrderStatus
      )
    }

    const debtor1HasPlacedSecondCourseOrderStatus = sessionStor.getItem(
      'acase-matter-debtor1hasplacedsecondcourseorderstatus'
    )
    if (debtor1HasPlacedSecondCourseOrderStatus) {
      activeCase.matter.debtor1HasPlacedSecondCourseOrderStatus = parseInt(
        debtor1HasPlacedSecondCourseOrderStatus
      )
    }

    const debtor1HasPlacedFirstCourseOrderStatusMessage = sessionStor.getItem(
      'acase-matter-debtor1hasplacedfirstcourseorderstatusmessage'
    )
    if (debtor1HasPlacedFirstCourseOrderStatusMessage) {
      activeCase.matter.debtor1HasPlacedFirstCourseOrderStatusMessage =
        debtor1HasPlacedFirstCourseOrderStatusMessage
    }

    const debtor1HasPlacedSecondCourseOrderStatusMessage = sessionStor.getItem(
      'acase-matter-debtor1hasplacedsecondcourseorderstatusmessage'
    )
    if (debtor1HasPlacedSecondCourseOrderStatusMessage) {
      activeCase.matter.debtor1HasPlacedSecondCourseOrderStatusMessage =
        debtor1HasPlacedSecondCourseOrderStatusMessage
    }

    const debtor2FirstCourseForJointCaseOrders = sessionStor.getItem(
      'acase-matter-debtor2firstcourseforjointcaseorders'
    )
    if (debtor2FirstCourseForJointCaseOrders) {
      activeCase.matter.debtor2FirstCourseForJointCaseOrders = parseInt(
        debtor2FirstCourseForJointCaseOrders
      )
    }

    const debtor2SecondCourseForJointCaseOrders = sessionStor.getItem(
      'acase-matter-debtor2secondcourseforjointcaseorders'
    )
    if (debtor2SecondCourseForJointCaseOrders) {
      activeCase.matter.debtor2SecondCourseForJointCaseOrders = parseInt(
        debtor2SecondCourseForJointCaseOrders
      )
    }

    const debtor2HasPlacedFirstCourseOrder = sessionStor.getItem(
      'acase-matter-debtor2hasplacedfirstcourseorder'
    )
    if (debtor2HasPlacedFirstCourseOrder) {
      activeCase.matter.debtor2HasPlacedFirstCourseOrder =
        debtor2HasPlacedFirstCourseOrder === 'true'
    }

    const debtor2HasPlacedSecondCourseOrder = sessionStor.getItem(
      'acase-matter-debtor2hasplacedsecondcourseorder'
    )
    if (debtor2HasPlacedSecondCourseOrder) {
      activeCase.matter.debtor2HasPlacedSecondCourseOrder =
        debtor2HasPlacedSecondCourseOrder === 'true'
    }

    const debtor2HasPlacedFirstCourseOrderStatus = sessionStor.getItem(
      'acase-matter-debtor2hasplacedfirstcourseorderstatus'
    )
    if (debtor2HasPlacedFirstCourseOrderStatus) {
      activeCase.matter.debtor2HasPlacedFirstCourseOrderStatus = parseInt(
        debtor2HasPlacedFirstCourseOrderStatus
      )
    }

    const debtor2HasPlacedSecondCourseOrderStatus = sessionStor.getItem(
      'acase-matter-debtor2hasplacedsecondcourseorderstatus'
    )
    if (debtor2HasPlacedSecondCourseOrderStatus) {
      activeCase.matter.debtor2HasPlacedSecondCourseOrderStatus = parseInt(
        debtor2HasPlacedSecondCourseOrderStatus
      )
    }

    const debtor2HasPlacedFirstCourseOrderStatusMessage = sessionStor.getItem(
      'acase-matter-debtor2hasplacedfirstcourseorderstatusmessage'
    )
    if (debtor2HasPlacedFirstCourseOrderStatusMessage) {
      activeCase.matter.debtor2HasPlacedFirstCourseOrderStatusMessage =
        debtor2HasPlacedFirstCourseOrderStatusMessage
    }

    const debtor2HasPlacedSecondCourseOrderStatusMessage = sessionStor.getItem(
      'acase-matter-debtor2hasplacedsecondcourseorderstatusmessage'
    )
    if (debtor2HasPlacedSecondCourseOrderStatusMessage) {
      activeCase.matter.debtor2HasPlacedSecondCourseOrderStatusMessage =
        debtor2HasPlacedSecondCourseOrderStatusMessage
    }

    const showQuestionnaire = sessionStor.getItem(
      'acase-matter-show-questionnaire'
    )
    if (showQuestionnaire) {
      activeCase.matter.questionnaireDisplayInClientPortalFlag =
        showQuestionnaire === 'true'
    }

    const expectedCompletionDate = sessionStor.getItem(
      'acase-matter-qexpectedcomplete'
    )
    if (expectedCompletionDate) {
      activeCase.matter.questionnaireExpectedCompletionDate =
        expectedCompletionDate
    }

    const expectedCompletionMonth = sessionStor.getItem(
      'acase-matter-qexpectedmonth'
    )
    if (expectedCompletionMonth) {
      activeCase.matter.questionnaireExpectedCompletionMonth =
        expectedCompletionMonth
    }

    const expectedCompletionDay = sessionStor.getItem(
      'acase-matter-qexpectedday'
    )
    if (expectedCompletionDay) {
      activeCase.matter.questionnaireExpectedCompletionDay =
        expectedCompletionDay
    }

    const expectedCompletionYear = sessionStor.getItem(
      'acase-matter-qexpectedyear'
    )
    if (expectedCompletionYear) {
      activeCase.matter.questionnaireExpectedCompletionYear =
        expectedCompletionYear
    }

    const questionnaireExpectedCompletionFormatted = sessionStor.getItem(
      'acase-matter-qexpectedformatted'
    )
    if (questionnaireExpectedCompletionFormatted) {
      activeCase.matter.questionnaireExpectedCompletionFormatted =
        questionnaireExpectedCompletionFormatted
    }

    const instructions = sessionStor.getItem('acase-matter-qinstr')
    if (instructions) {
      activeCase.matter.questionnaireInstructions = instructions
    }

    const showInstructions = sessionStor.getItem('acase-matter-qshow-instr')
    if (showInstructions) {
      activeCase.matter.questionnaireShownInstructionsFlag =
        showInstructions === 'true'
    }

    const showTerms = sessionStor.getItem('acase-matter-qshow-instr')
    if (showTerms) {
      activeCase.matter.questionnaireShownTermsAndConditionsFlag =
        showTerms === 'true'
    }

    const dashBoardTitle = sessionStor.getItem('acase-matter-dbtitle')
    if (dashBoardTitle) {
      activeCase.matter.dashBoardTitle = dashBoardTitle
    }

    const dashBoardHeaderDescription = sessionStor.getItem(
      'acase-matter-dbheaderdescr'
    )
    if (dashBoardHeaderDescription) {
      activeCase.matter.dashBoardHeaderDescription = dashBoardHeaderDescription
    }

    const dashBoardCurrentStatusDescription = sessionStor.getItem(
      'acase-matter-dbcurrstatusdescr'
    )
    if (dashBoardCurrentStatusDescription) {
      activeCase.matter.dashBoardCurrentStatusDescription =
        dashBoardCurrentStatusDescription
    }

    const dashBoardShowSubmitDocumentsFlag = sessionStor.getItem(
      'acase-matter-dbshowsubmit'
    )
    if (dashBoardShowSubmitDocumentsFlag) {
      activeCase.matter.dashBoardShowSubmitDocumentsFlag =
        dashBoardShowSubmitDocumentsFlag === 'true'
    }

    const dashBoardCourseNumber = sessionStor.getItem(
      'acase-matter-dbcoursenum'
    )
    if (dashBoardCourseNumber) {
      activeCase.matter.dashBoardCourseNumber = dashBoardCourseNumber
    }

    const statusList: CaseStatus[] = []
    for (let index = 0; index < 10; index++) {
      const item = getActiveCaseStatusListFromSessionStorage(index)
      if (item) {
        statusList.push(item)
      } else {
        break
      }
    }

    if (statusList.length > 0) {
      activeCase.matter.statuses = statusList
    }

    if (activeCase.matter.firm) {
      const firmId = sessionStor.getItem('acase-matter-firm-id')
      if (firmId) {
        activeCase.matter.firm.id = parseInt(firmId)
      }
      const firmName = sessionStor.getItem('acase-matter-firm-name')
      if (firmName) {
        activeCase.matter.firm.name = firmName
      }

      const firmOfficeId = sessionStor.getItem('acase-matter-firm-offId')
      if (firmOfficeId) {
        activeCase.matter.firm.officeId = firmOfficeId
      }

      const emailAddress = sessionStor.getItem('acase-matter-firm-email')
      if (emailAddress) {
        activeCase.matter.firm.emailAddress = emailAddress
      }

      const iconUrl = sessionStor.getItem('acase-matter-firm-icon')
      if (iconUrl) {
        activeCase.matter.firm.iconUrl = iconUrl
      }

      const street = sessionStor.getItem('acase-matter-firm-street')
      if (street) {
        activeCase.matter.firm.street = street
      }

      const city = sessionStor.getItem('acase-matter-firm-city')
      if (city) {
        activeCase.matter.firm.city = city
      }

      const state = sessionStor.getItem('acase-matter-firm-state')
      if (state) {
        activeCase.matter.firm.state = state
      }

      const zip = sessionStor.getItem('acase-matter-firm-zip')
      if (zip) {
        activeCase.matter.firm.zip = zip
      }

      const phone = sessionStor.getItem('acase-matter-firm-phone')
      if (phone) {
        activeCase.matter.firm.phone = phone
      }
    }
  }
  return activeCase
}
